<div id="next-rich-text" class="ql-editor">
    <div class="ql-container ql-snow ngx-quill-view-html" [innerHTML]="field.text"></div>
</div>
